import styled from "@emotion/styled";

type TProps<T> = {
  tabs: { label: string; value: T }[];
  onTabChange?: (activeTabIndex: number, activeTab: T) => void;
  activeTabIndex: number;
};

export const TermTypeTabs = <T,>({ tabs, onTabChange, activeTabIndex }: TProps<T>) => {
  const handleOnClickTab = (index: number) => {
    if (onTabChange) onTabChange(index, tabs[index].value);
  };
  return (
    <Layout>
      {tabs.map((tab, i) => {
        return (
          <li
            role="presentation"
            key={i}
            className={activeTabIndex === i ? "active" : ""}
            onClick={() => handleOnClickTab(i)}
          >
            <p>{tab.label}</p>
          </li>
        );
      })}
    </Layout>
  );
};

const Layout = styled.ul`
  display: flex;
  border-bottom: 1px solid #adadad;
  margin: 0 auto;
  width: 100%;

  li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 50px;

    color: #adadad;
    border-bottom: 2px solid white;
    cursor: pointer;
    transition: all 0.5s ease;

    p {
      text-align: center;
      width: 100%;
      font-size: 16px;
      line-height: 25px;
      letter-spacing: -0.25px;
    }

    &.active {
      border-bottom: 2px solid #5e67ba;

      P {
        color: #5e67ba;
        font-weight: 700;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down("TABLET")} {
    width: 100%;
    li {
      width: 100%;

      p {
        font-size: 14px;
      }
    }
  }
`;
